// extracted by mini-css-extract-plugin
export default {"button":"button__EpigenomesTableToggle__Xaf6O","chevronContainer":"chevronContainer__EpigenomesTableToggle__Xaf6O"};